import {Component, HostListener, OnInit} from '@angular/core';
import {AppComponent} from '../../app.component';
import {FormControl, FormGroup} from '@angular/forms';
import {Breakpoints, MediaMatcher} from '@angular/cdk/layout';

@Component({
  selector: 'app-mfa-form',
  templateUrl: './mfa-form.component.html',
  styleUrls: ['../login-form/login-form.component.scss', './mfa-form.component.scss']
})
export class MfaFormComponent implements OnInit {

  faCodeError = '';
  setupSmsForm = new FormGroup ({
    phone_number: new FormControl('')
  });
  enter2facodeForm = new FormGroup ({
    code_2fa: new FormControl('')
  });

  layoutMatches = {
    isHandsetDefaultLayout: false
  }

  @HostListener('window:resize', ['$event']) public onLayoutChange($event) {
    this.setLayoutMatches();
  }

  constructor(
    public application: AppComponent,
    private mediaMatcher: MediaMatcher) {
    this.setLayoutMatches();
  }

  private setLayoutMatches() {
    const handsetBreakPoints = Breakpoints.Handset.split(', ');
    let isHandset = false;
    handsetBreakPoints.forEach(media => {
      if (this.mediaMatcher.matchMedia(media).matches) {
        isHandset = true;
      }
    })
    if (isHandset) {
      this.toggleLayout('isHandsetDefaultLayout')
    } else {
      this.purgeLayout()
    }
  }

  private toggleLayout(key: string) {
    for ( const x in this.layoutMatches ) {
      if (x === key) {
        this.layoutMatches[x] = true;
      } else {
        this.layoutMatches[x] = false;
      }
    }
  }

  private purgeLayout() {
    for ( const x in this.layoutMatches ) {
      if (this.layoutMatches[x]) {
        this.layoutMatches[x] = false;
      }
    }
  }

  ngOnInit() {
    this.application.mfaFormComponent = this;
  }

  public doLogin() {
    // let loginValue:string = this.loginForm.get('login').value;
    // let passwordValue:string = this.loginForm.get('password').value;
    // this.application.doLogin(loginValue,passwordValue);
  }

  public confirmGaMfa() {
    // let loginValue:string = this.loginForm.get('login').value;
    // let passwordValue:string = this.loginForm.get('password').value;
    // this.application.doLogin(loginValue,passwordValue);
    this.application.state = 'enter_mfa_ga';
  }

  public cancel2faCode() {
    this.application.state = 'login';
  }

  public setupSmsCode() {
    const phoneNumber: string = this.setupSmsForm.get('phone_number').value;
    // this.application.activeRequest = true;
    this.application.apiService.setupMfa('SMS', phoneNumber.trim()).subscribe(
      responseData => this.sentPhoneToken(responseData),
      error => this.setError(error)
    );
  }

  public sentPhoneToken(responseData: object) {
    // this.application.activeRequest = false;
    this.faCodeError = '';
    this.application.state = 'enter_mfa_sms';
  }

  public send2faCode(mfaType: string) {
    const codeValue: string = this.enter2facodeForm.get('code_2fa').value;
    // this.application.activeRequest = true;
    this.application.apiService.send2faCode(codeValue.trim(), mfaType).subscribe(
      auth => this.checkCodeResult(auth),
      error => this.setError(error)
    );
  }
  private checkCodeResult(auth) {
    // this.application.activeRequest = false;
    if (auth && auth.success) {
      this.faCodeError = '';
      this.application.getCurrentUser(true);
    } else {
      this.faCodeError = 'Sorry, the code you entered is invalid or already expired.';
    }
  }
  private setError({ errMsg, exception }) {
    // this.application.activeRequest = false;
    // this.appError = errMsg.toString();
    this.faCodeError = errMsg.toString();
  }

}
